export const JobFunnelNameOptions: { [key: string]: string } = {
    Applied: 'applicant-tracker.applied',
    Contacted: 'applicant-tracker.contacted',
    'Scheduled Interview': 'applicant-tracker.scheduled-interview',
    'Passed Interview': 'applicant-tracker.passed-interview',
    'Submitted documents': 'applicant-tracker.submitted-documents',
    'Ready to hire': 'applicant-tracker.ready-to-hire',
    Interviewed: 'applicant-tracker.interviewed',
};
